import * as React from 'react';
import { Button } from '../Button/index.js';
export var TabTitle = function (_a) {
    var title = _a.title, setActive = _a.setActive, active = _a.active;
    return (React.createElement("li", null,
        React.createElement(Button, { type: "button", onClick: setActive, kind: active ? 'primary' : 'secondary' }, title)));
};
//# sourceMappingURL=TabTitle.js.map